import { useState } from 'react'
import './App.css'
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import HomeLayout from './layouts/HomeLayout';
import HomePage from './pages/HomePage';
import CareerDetails from './pages/CareerDetails';
import Registration from './pages/Registration';
import Logout from './pages/Logout';
import Login from './pages/Login';
import ForgetPassword from './pages/ForgetPassword';
import MainLayout from './layouts/MainLayout';
import NotFound from './pages/NotFound';
import Dashboard from './pages/Dashboard';
import Dcareer from './pages/Dcareer';
import UpdateProfile from './pages/UpdateProfile';
import ProfileView from './pages/ProfileView';
import ApplyJob from './pages/ApplyJob';
import AppliedJob from './pages/AppliedJob';
import BasicSetting from './pages/BasicSetting';

function App() {
  const [count, setCount] = useState(0)

  return (
    <Router>
		<Routes>
			<Route path="/" element={<HomeLayout />}>
				<Route index element={<HomePage />} />
				<Route path="/career/:id" element={<CareerDetails />} />
				<Route path="/registration" element={<Registration />} />
				<Route path="/forget-password" element={<ForgetPassword />} />
				
				<Route  path="logout" element={
				  <AuthProvider>
					<Logout />
				  </AuthProvider>
				} />
				
				<Route  path="login" element={
				  <AuthProvider>
					<Login />
				  </AuthProvider>
				} />
				<Route path="*" element={<NotFound />} />
			</Route>
			<Route path="/dashboard" element={
				<AuthProvider>
					<ProtectedRoute>
						<MainLayout />
					</ProtectedRoute>
				</AuthProvider>
				}
				>
				<Route index element={<Dashboard />} />
				<Route path="career/:id" element={<Dcareer />} />
				<Route path="update-profile" element={<UpdateProfile />} />
				<Route path="view-profile" element={<ProfileView />} />
				<Route path="apply/:jobId" element={<ApplyJob />} />
				<Route path="applied-jobs" element={<AppliedJob />} />
				<Route path="settings" element={<BasicSetting />} />
			</Route>	
		</Routes>
	</Router>
  )
}

export default App
